import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Testimonials() {
  const headerRef = useScrollAnimation();
  const cardsRef = useScrollAnimation({ delay: 100 });
  
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Legacy Family Yara',
      date: 'July 9, 2024',
      rating: 5,
      text: 'I was referred to Benny and had never worked out in a gym before. He was incredibly professional, patient, and made me feel comfortable from day one. Life-changing experience.',
      image: 'https://img1.wsimg.com/isteam/ip/79f03f3e-096e-49e4-9086-49ca6ab90ae6/Screenshot%202026-01-03%20at%209.48.05%E2%80%AFPM.png',
      link: 'https://youtube.com/shorts/IEH2Yqu5GH4?si=YiDMNql09LHdUo8x',
    },
    {
      name: 'Legacy Family David',
      date: 'April 20, 2023',
      rating: 5,
      text: 'I lost over 90 pounds and completely transformed my mindset through the Legacy Family program. The structure, accountability, and genuine care made all the difference.',
      image: 'https://img1.wsimg.com/isteam/ip/79f03f3e-096e-49e4-9086-49ca6ab90ae6/IMG-3355.jpg',
      link: 'https://youtu.be/y-LnnuLx9xQ?si=ZQ7oVgIeyt6smoio',
    },
    {
      name: 'Legacy Family Kevin',
      date: 'October 2, 2025',
      rating: 5,
      text: 'I saw Benny on Instagram and thought this guy is serious! I reached out and he completely changed my approach to fitness and nutrition. Best decision I ever made.',
      image: 'https://img1.wsimg.com/isteam/ip/79f03f3e-096e-49e4-9086-49ca6ab90ae6/8AF7DBC5-07A5-4FAA-B2FD-62730B8A955B.JPG',
      link: 'https://youtube.com/shorts/MRWlpxZvlIg?si=tV6FCPwVj-BIlEVF',
    },
  ];

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section id="testimonials" className="py-20 sm:py-24" style={{ background: '#f9f6ef' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={headerRef} className="animate-fade-up text-center mb-12 sm:mb-16">
          <p className="text-sm font-bold tracking-[0.3em] uppercase mb-3" style={{ color: '#C8102E' }}>
            Success Stories
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4" style={{ color: '#000000' }}>
            Words from The Legacy Family
          </h2>
          <div className="w-16 h-1 mx-auto rounded-full" style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)' }} />
        </div>

        {/* Mobile: single card slider */}
        <div className="block md:hidden">
          <div
            className="rounded-2xl p-6 shadow-sm"
            style={{ background: '#ffffff', border: '1px solid #f0e0b0' }}
          >
            <div className="flex flex-col items-center text-center">
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                className="w-20 h-20 rounded-full object-cover object-top mb-4"
                style={{ border: '3px solid #B8860B' }}
              />
              <div className="flex gap-1 mb-3">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-base" style={{ color: '#F5D76E' }}></i>
                ))}
              </div>
              <h4 className="text-lg font-bold mb-2" style={{ color: '#000000' }}>{testimonials[currentIndex].name}</h4>
              <p className="text-sm leading-relaxed mb-5" style={{ color: '#555555' }}>{testimonials[currentIndex].text}</p>
              <a
                href={testimonials[currentIndex].link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-bold flex items-center gap-1 cursor-pointer"
                style={{ color: '#C8102E' }}
              >
                Watch full story <i className="ri-arrow-right-line"></i>
              </a>
              <p className="text-xs mt-4" style={{ color: '#B8860B' }}>{testimonials[currentIndex].date}</p>
            </div>
          </div>
          <div className="flex justify-center items-center gap-4 mt-6">
            <button
              onClick={prevSlide}
              className="w-10 h-10 rounded-full shadow-md flex items-center justify-center cursor-pointer"
              style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className="w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer"
                  style={{ background: idx === currentIndex ? '#C8102E' : '#d4b86a', opacity: idx === currentIndex ? 1 : 0.5 }}
                />
              ))}
            </div>
            <button
              onClick={nextSlide}
              className="w-10 h-10 rounded-full shadow-md flex items-center justify-center cursor-pointer"
              style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Desktop: 3-column grid with arrows */}
        <div ref={cardsRef} className="animate-fade-up hidden md:block relative">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-5 z-10 w-11 h-11 rounded-full shadow-md flex items-center justify-center transition-all duration-300 cursor-pointer"
            style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div className="grid md:grid-cols-3 gap-6">
            {testimonials.map((testimonial, idx) => (
              <div
                key={idx}
                className={`rounded-2xl p-8 shadow-sm transition-all duration-300 ${idx === currentIndex ? 'opacity-100 scale-100' : 'opacity-40'}`}
                style={{ background: '#ffffff', border: '1px solid #f0e0b0' }}
              >
                <div className="flex flex-col items-center text-center">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-20 h-20 rounded-full object-cover object-top mb-4"
                    style={{ border: '3px solid #B8860B' }}
                  />
                  <div className="flex gap-1 mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-base" style={{ color: '#F5D76E' }}></i>
                    ))}
                  </div>
                  <h4 className="text-lg font-bold mb-2" style={{ color: '#000000' }}>{testimonial.name}</h4>
                  <p className="text-sm leading-relaxed mb-5" style={{ color: '#555555' }}>{testimonial.text}</p>
                  <a
                    href={testimonial.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-bold flex items-center gap-1 cursor-pointer transition-colors duration-200"
                    style={{ color: '#C8102E' }}
                  >
                    Watch full story <i className="ri-arrow-right-line"></i>
                  </a>
                  <p className="text-xs mt-4" style={{ color: '#B8860B' }}>{testimonial.date}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-5 z-10 w-11 h-11 rounded-full shadow-md flex items-center justify-center transition-all duration-300 cursor-pointer"
            style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        <div className="hidden md:flex justify-center gap-2 mt-8">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className="w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer"
              style={{ background: idx === currentIndex ? '#C8102E' : '#d4b86a', opacity: idx === currentIndex ? 1 : 0.5 }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}